import type { AssetTypeSelectOptionProps } from "./asset-type-select-option.type";

import { Select } from "antd";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

export const AssetTypeSelectOption = ({
  option,
}: AssetTypeSelectOptionProps) => {
  return (
    <Option key={option.id} value={option.id}>
      {option.name}
    </Option>
  );
};
